import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Button, Grid, Icon, Input, Popup } from 'semantic-ui-react';
import moment from 'moment';
import { toast } from 'react-toastify';

import { adPreviewScrolling } from '../../../actions';
import getFullNameOrUserName from '../../../utils/user';
import { insertAdNote, updateNote } from '../../../services/AdServiceManager';

class AdNoteDetail extends PureComponent {
  state = {
    clearNoteOpen: false,
    note: '',
    processingClear: false
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.isScrolling) {
      this.setState({
        ...this.state,
        clearNoteOpen: false,
        note: ''
      });
    }
  }

  getIconName = (noteType) => {
    switch (noteType) {
      case '0':
      case '4':
        return 'comments';
      case '1':
        return 'check';
      case '2':
        return 'stop';
      case '3':
      case '5':
        return 'warning sign';
      default:
        return 'comments';
    }
  };

  getIconColor = (note) => {
    switch (note.note_type) {
      case '0':
      case '4':
        return note.note_qc ? 'yellow' : 'green';
      case '1':
        return 'green';
      case '2':
        return 'grey';
      case '3':
        return 'red';
      case '5':
        return 'green';
      default:
        return 'green';
    }
  };

  insertNoteQC = async (adId, email, fullname, note) => {
    const { noteText } = note;
    const clearNote =
      note && noteText !== ''
        ? noteText
        : `Note clear successfully by ${fullname === '' ? email : fullname}`;
    const noteToInsert = {
      ad_id: adId,
      note_text: clearNote,
      username: email,
      fullname,
      note_qc: false,
      note_type: 4
    };
    const result = await insertAdNote(noteToInsert);
    return result;
  };

  clearNote = () => {
    const { adPreview, user, adNote, updateParent } = this.props;
    const adId = adPreview.ad_id;
    const { email } = user;
    const fullname = getFullNameOrUserName(user);
    const note = {
      ...adNote,
      note_qc: false
    };
    this.setState({ ...this.state, processingClear: true }, async () => {
      await updateNote(note);
      const result = await this.insertNoteQC(adId, email, fullname, note);
      const { allNotes } = result;

      toast('Note clear successfully!', {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
        type: toast.TYPE.SUCCESS,
        hideProgressBar: true
      });
      this.setState({
        ...this.state,
        clearNoteOpen: false,
        note: '',
        processingClear: false
      });
      if (updateParent) {
        const newStateAd = {
          ...adPreview,
          adNotes: allNotes
        };
        updateParent(newStateAd);
      }
    });
  };

  render() {
    const { clearNoteOpen, note, processingClear } = this.state;
    const { adNote, actions } = this.props;
    const {
      createdDate,
      fullname,
      username,
      note_type: noteType,
      note_qc: noteQc,
      noteText
    } = adNote || {};
    const date = moment(createdDate);
    return (
      <Grid.Row>
        <Grid.Column width={16}>
          <p>{noteText}</p>
          <small>
            {fullname === '' ? username : fullname} - <i>{date.fromNow()}</i>
          </small>
          <Icon
            name={this.getIconName(noteType)}
            color={this.getIconColor(adNote)}
            inverted={noteType === '2'}
          />
        </Grid.Column>
        {noteQc ? (
          <Grid.Column width={16}>
            <Popup
              flowing
              on="click"
              open={clearNoteOpen}
              trigger={
                <Button
                  onClick={() => {
                    this.setState({
                      ...this.state,
                      clearNoteOpen: !clearNoteOpen,
                      holdOpen: false
                    });
                    actions.adPreviewScrolling(false);
                  }}
                  color="green"
                >
                  Clear Note
                </Button>
              }
            >
              <Grid>
                <Grid.Row>
                  <Grid.Column>
                    <Input
                      fluid
                      placeholder="Add Note to the Clear Note"
                      value={note}
                      onChange={(event, data) => {
                        this.setState({ ...this.state, note: data.value });
                      }}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column>
                    <Button
                      loading={processingClear}
                      onClick={() => {
                        this.clearNote();
                      }}
                      color="blue"
                    >
                      Clear
                    </Button>
                    <Button
                      onClick={() => {
                        this.setState({
                          ...this.state,
                          clearNoteOpen: false,
                          note: ''
                        });
                      }}
                      color="red"
                    >
                      Cancel
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Popup>
          </Grid.Column>
        ) : null}
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => ({
  isScrolling: state.adPreview.isScrolling
});

const mapDispatchToProps = (dispatch) => ({
  actions: {
    adPreviewScrolling: (isScrolling) => {
      dispatch(adPreviewScrolling(isScrolling));
    }
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdNoteDetail);



// WEBPACK FOOTER //
// ./src/screens/Flipper/ParentSection/AdNoteDetail.js